import React from 'react';
import { NextPage } from 'next';
import { SpacingLayout } from 'components/atoms';
import { CookiePolicy } from 'templates/company';
import { SEO } from 'templates/layout';

const Privacy: NextPage = () => {
  return (
    <SpacingLayout>
      <SEO title={'Cookie Policy'} />
      <CookiePolicy />
    </SpacingLayout>
  );
};

export default Privacy;
